// extracted by mini-css-extract-plugin
export var li = "_vw-2";
export var ol = "_vw-1";
export var ul = "_vw-0";